import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avatar-upload" }
const _hoisted_2 = { class: "avatar-edit" }
const _hoisted_3 = { class: "avatar-preview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "file",
        id: "imageUpload",
        accept: ".png, .jpg, .jpeg",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
      }, null, 32),
      _cache[1] || (_cache[1] = _createElementVNode("label", { for: "imageUpload" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        id: "imagePreview",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.previewImage})` })
      }, null, 4)
    ])
  ]))
}